import React, { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { Tag, X } from "lucide-react";

// type: "class" | "workshop" | "event". onApplied(result|null) — result has {code, discount, final}.
export const PromoCodeInput = ({ type, amount, batchId, onApplied, testId = "promo" }) => {
  const [enabled, setEnabled] = useState(false);
  const [code, setCode] = useState("");
  const [applied, setApplied] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/promo/enabled").then(r => setEnabled(!!r.data.enabled)).catch(() => {}); }, []);
  useEffect(() => { if (applied) apply(applied.code); }, [amount]); // eslint-disable-line react-hooks/exhaustive-deps

  const apply = async (c = code) => {
    if (!c.trim()) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/promo/validate", { code: c.trim(), type, amount: Number(amount) || 0, batch_id: batchId || null });
      setApplied(data); onApplied(data);
    } catch (e) {
      setApplied(null); onApplied(null);
      setError(e.response?.data?.detail || "Invalid promo code");
    } finally { setBusy(false); }
  };
  const clear = () => { setApplied(null); setCode(""); setError(""); onApplied(null); };

  if (!enabled) return null;
  return (
    <div className="my-4" data-testid={`${testId}-wrap`}>
      {applied ? (
        <div className="flex items-center justify-between gap-2 text-sm text-emerald-300 border border-emerald-500/30 bg-emerald-500/10 px-4 py-3" data-testid={`${testId}-applied`}>
          <span className="flex items-center gap-2"><Tag size={14}/> <strong className="font-mono">{applied.code}</strong> applied · you save ${Number(applied.discount).toFixed(2)}</span>
          <button type="button" onClick={clear} aria-label="Remove promo" data-testid={`${testId}-remove`}><X size={14}/></button>
        </div>
      ) : (
        <div className="flex gap-2">
          <input value={code} onChange={e => setCode(e.target.value.toUpperCase())} onKeyDown={e => e.key === "Enter" && (e.preventDefault(), apply())}
                 placeholder="Promo code" className="flex-1 bg-black border border-white/10 px-4 py-3 font-mono uppercase focus:border-red-600 outline-none" data-testid={`${testId}-input`} />
          <button type="button" onClick={() => apply()} disabled={busy || !code.trim()} className="px-5 border border-white/20 hover:border-white text-sm uppercase tracking-wider disabled:opacity-50" data-testid={`${testId}-apply`}>
            {busy ? "…" : "Apply"}
          </button>
        </div>
      )}
      {error && <p className="text-red-400 text-xs mt-2" data-testid={`${testId}-error`}>{error}</p>}
    </div>
  );
};
